import { Component } from '@angular/core';

@Component({
    selector: 'lib-lib',
    standalone: true,
    imports: [],
    template: `
    <p>
      lib works!
    </p>
  `,
    styles: ``
})
export class LibComponent {

}
